export function constrainReportLayout(layout, canvas) {
  const w = Math.min(canvas.width, Math.max(80, Number(layout.w) || 80))
  const h = Math.min(canvas.height, Math.max(50, Number(layout.h) || 50))
  return { x: Math.max(0, Math.min(canvas.width - w, Number(layout.x) || 0)), y: Math.max(0, Math.min(canvas.height - h, Number(layout.y) || 0)), w, h }
}

export function copyReportPage(page) {
  const copy = structuredClone(page)
  return { ...copy, id: crypto.randomUUID(), widgets: copy.widgets.map((widget) => ({ ...widget, id: crypto.randomUUID() })) }
}
